exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.right-dialog .el-transfer-panel {\n  width: 240px;\n}\n.right-dialog .el-transfer-panel__footer {\n  height: 38px;\n  clear: both;\n}\n.transfer-footer {\n  padding: 6px 5px;\n}\n.alert-txt {\n  padding: 15px 0;\n}\n.delay-dialog .el-textarea {\n  width: 80%;\n  vertical-align: middle;\n}\n.delay-dialog .option-box {\n  padding: 15px 0;\n}\n.delay-dialog .option-box .el-date-editor {\n    width: 70%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-43334786","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/theme.scss","/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/_mixin.scss"]}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/view/member/members/rightsList.vue
// module id = 1421
// module chunks = 0